
import { BannerItem } from "./interface"
import { menus } from "../sidebar/data"
import Banner100 from "@/assets/images/100banner-new.jpg"
import Leader from "@/assets/images/leader.jpg"
import Journey from "@/assets/images/journey.jpg"
import Famous from "@/assets/images/famous.jpg"
import Case from "@/assets/images/case.jpg"
import Old from "@/assets/images/old.jpg"
import Grace from "@/assets/images/grace.jpg"
import Banner20 from "@/assets/images/magazine.jpg"
const BasePath = "../../assets/images/"
export const bannerList: Array<BannerItem> = [
  {
    path: "/100", banner: Banner100
  }, {
    path: "/leader", banner: Leader
  }, {
    path: "/journey", banner: Journey
  }, {
    path: "/famous", banner: Famous
  }, {
    path: "/old", banner: Old
  },  {
    path: "/case", banner: Case
  },{
    path: "/grace", banner: Grace
  }, {
    path: "/20", banner: Banner20
  }
]